import React from 'react'
import SmartNavigator from '../generic/SmartNavigator'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import Sequencer from '../sequencer/Sequencer'
const MainSequencer = () => {
  const { t_ } = useSmartTranslation()
  const componentsInfo = [
    {
      title: t_('Sequencer'),
      component: <Sequencer />,
      permissionCode: 'SEQUENCER'
    }
  ]
  return (
    <div>
      <SmartNavigator componentsInfo={componentsInfo} />
    </div>
  )
}

export default MainSequencer
